'use strict'

module.exports = {
  tag: '/plaintext/1.0.0',
  encrypt (id, privKey, conn) {
    return conn
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-swarm/src/plaintext.js
// module id = 258
// module chunks = 0